import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer className="py-16 bg-slate text-foreground">
      <div className="container mx-auto px-6">
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          {/* Brand */}
          <div className="md:col-span-1">
            <div className="flex items-center gap-3 mb-4">
              <img src="/ll-mark-256.png" alt="LegacyLens AI" className="h-10 w-auto" />
              <span className="font-display text-xl font-semibold text-foreground">
                LegacyLens <span className="text-ivory">AI</span>
              </span>
            </div>
            <p className="text-muted-foreground text-sm leading-relaxed">
              A family tree where every name has a voice. Capture someone's voice, presence, and stories while they're still here — preserved consent-first for the generations that follow.
            </p>
          </div>

          {/* Platform */}
          <div>
            <h4 className="font-semibold text-foreground mb-4">Platform</h4>
            <ul className="space-y-3 text-sm text-muted-foreground">
              <li>
                <a
                  href="#how-it-works"
                  onClick={(e) => {
                    e.preventDefault();
                    document.getElementById("how-it-works")?.scrollIntoView({ behavior: "smooth" });
                  }}
                  className="hover:text-foreground transition-colors"
                >
                  How It Works
                </a>
              </li>
              <li>
                <Link to="/tribute/syrus-demo" className="hover:text-foreground transition-colors">
                  View Demo
                </Link>
              </li>
            </ul>
          </div>

          {/* Company */}
          <div>
            <h4 className="font-semibold text-foreground mb-4">Company</h4>
            <ul className="space-y-3 text-sm text-muted-foreground">
              <li>
                <Link to="/about" className="hover:text-foreground transition-colors">
                  About Us
                </Link>
              </li>
              <li>
                <Link to="/contact" className="hover:text-foreground transition-colors">
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Trust & Safety */}
          <div>
            <h4 className="font-semibold text-foreground mb-4">Trust & Safety</h4>
            <ul className="space-y-3 text-sm text-muted-foreground">
              <li>
                <Link to="/digital-legacy-directive" className="hover:text-foreground transition-colors">
                  The Directive
                </Link>
              </li>
              <li>
                <Link to="/privacy" className="hover:text-foreground transition-colors">
                  Privacy Policy
                </Link>
              </li>
              <li>
                <Link to="/terms" className="hover:text-foreground transition-colors">
                  Terms of Service
                </Link>
              </li>
              <li>
                <Link to="/cookie-policy" className="hover:text-foreground transition-colors">
                  Cookie Policy
                </Link>
              </li>
              <li>
                <Link to="/data-security" className="hover:text-foreground transition-colors">
                  Data Security
                </Link>
              </li>
              <li>
                <Link to="/ethics" className="hover:text-foreground transition-colors">
                  Ethics Guidelines
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom */}
        <div className="pt-8 border-t border-border/30 flex flex-col sm:flex-row items-center justify-between gap-2">
          <p className="text-sm text-muted-foreground">
            © 2026 LegacyLens AI. All rights reserved.
          </p>
          <Link to="/admin/login" className="text-xs text-muted-foreground/50 hover:text-muted-foreground transition-colors">
            Admin
          </Link>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
